import '@mantine/core/styles.css';
import { MantineProvider, AppShell } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { OrdersList } from './components/OrdersList';
import { OrderDetails } from './components/OrderDetails';
import { Navigation } from './components/Navigation';
import { theme } from './theme';

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <Router>
          <AppShell
            header={{ height: 60 }}
            navbar={{ width: 300, breakpoint: 'sm' }}
            padding="md"
          >
            <AppShell.Header p="xs">Service Delivery Portal</AppShell.Header>
            <AppShell.Navbar p="xs"><Navigation /></AppShell.Navbar>
            <AppShell.Main style={{ backgroundColor: '#f8f9fa' }}>
            <Routes>
              <Route path="/" element={<OrdersList />} />
              <Route path="/orders/:orderId" element={<OrderDetails />} />
            </Routes>
            </AppShell.Main>
          </AppShell>
        </Router>
      </MantineProvider>
    </QueryClientProvider>
  );
}
